// Copyright ©️ 2025 eVolve MEP, LLC

import { createBrowserHistory } from 'history';

export const routerHistory = createBrowserHistory();
